module.exports = __webpack_public_path__ + "static/media/product6.937e2cfb.jpg";